import { useNavigate } from "react-router-dom";
import IntlMessages from "@lib/helpers/IntlMessages";
import AppAnimate from "@lib/components/AppComponents/AppAnimate";
import AppPageMeta from "@lib/components/AppComponents/AppPageMeta";
import Logo from "@assets/icon/500.svg";
import {
  StyledErrorButton,
  StyledErrorContainer,
  StyledErrorContent,
  StyledErrorImage,
  StyledErrorPara,
} from "../index.styled";
import { AppLayout } from "@lib/components/AppComponents";

const Error500 = () => {
  const navigate = useNavigate();

  const onGoBackToHome = () => {
    navigate(-1);
  };

  return (
    <AppLayout>
      <AppPageMeta title="Server Error" />
      <AppAnimate animation="transition.slideUpIn" delay={200}>
        <StyledErrorContainer key="a">
          <StyledErrorImage>
            <img src={Logo} alt={Logo} />
          </StyledErrorImage>
          <StyledErrorContent>
            <h3>
              <IntlMessages id="error.500Error" />.
            </h3>
            <StyledErrorPara>
              <p className="mb-0">
                <IntlMessages id="error.500Message1" />
              </p>
              <p className="mb-0">
                <IntlMessages id="error.500Message2" />
              </p>
            </StyledErrorPara>
            <StyledErrorButton type="primary" onClick={onGoBackToHome}>
              <IntlMessages id="error.goBackToHome" />
            </StyledErrorButton>
          </StyledErrorContent>
        </StyledErrorContainer>
      </AppAnimate>
    </AppLayout>
  );
};

export default Error500;
